import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal, ActionModal, AcknowledgeModal, Text } from '@percent/lemonade'
import type { RemoveAdminModalProps } from './RemoveAdminModal.types'

export function RemoveAdminModal({
  isOpen,
  onClose,
  onConfirm,
  accountName,
  accountEmail,
  state,
  errorMessage,
}: RemoveAdminModalProps) {
  const { t } = useTranslation()

  const account = useMemo(() => {
    return accountName === accountEmail
      ? accountEmail
      : `${accountName} (${accountEmail})`
  }, [accountName, accountEmail])

  if (!isOpen) return null

  if (state === 'success') {
    return (
      <Modal open={isOpen} onClose={onClose}>
        <AcknowledgeModal
          result="positive"
          title={t('modal.accounts.removeAdmin.successTitle')}
          description={t('modal.accounts.removeAdmin.successDescription', {
            account,
          })}
          buttonText={t('button.close')}
          buttonTestId="remove-admin-success-close-button"
          handleClose={onClose}
        />
      </Modal>
    )
  }

  if (state === 'error') {
    return (
      <Modal open={isOpen} onClose={onClose}>
        <AcknowledgeModal
          result="negative"
          title={t('modal.accounts.removeAdmin.errorTitle')}
          description={
            errorMessage ||
            t('modal.accounts.removeAdmin.errorDescription', {
              account,
            })
          }
          buttonText={t('button.close')}
          buttonTestId="remove-admin-error-close-button"
          handleClose={onClose}
        />
      </Modal>
    )
  }

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ActionModal
        title={t('modal.accounts.removeAdmin.title')}
        primaryButtonText={t('button.removeAdmin')}
        secondaryButtonText={t('button.cancel')}
        primaryBtnTestId="remove-admin-submit-button"
        secondaryBtnTestId="remove-admin-cancel-button"
        handleSubmit={onConfirm}
        handleClose={onClose}
      >
        <Text>
          {t('modal.accounts.removeAdmin.description', {
            account,
          })}
        </Text>
      </ActionModal>
    </Modal>
  )
}
